import * as yup from 'yup';
import { TSelectOption } from '@spotted-zebra-uk/ui-components';

export const validationShema = yup.object().shape({
  name: yup
    .string()
    .ensure()
    .min(3, "Name can't be shorter than 3 characters!")
    .max(40, "Name can't be longer than 40 characters!")
    .required('Name is required')
    .test(
      'name-whitespace',
      'Name must not have leading or trailing whitespace!',
      name => {
        return !name.startsWith(' ') && !name.endsWith(' ');
      }
    ),
  description: yup
    .string()
    .min(10, "Description can't be shorter than 10 characters!")
    .max(200, "Description can't be longer than 200 characters!")
    .test(
      'description-whitespace',
      'Description must not have leading or trailing whitespace!',
      description => {
        if (!description) return true;
        return !description.startsWith(' ') && !description.endsWith(' ');
      }
    ),
});

export const dataTestIds = {
  form: 'add-technical-skill-drawer__form',
  save: 'add-technical-skill-drawer__save',
  cancel: 'add-technical-skill-drawer__cancel',
  nameInput: 'add-technical-skill-drawer__name-input',
  descriptionInput: 'add-technical-skill-drawer__description-input',
  ownershipSelect: 'add-technical-skill-drawer__ownership-select',
};

export type AddTechnicalSkillFormValues = {
  name: string;
  description: string;
  ownership: TSelectOption;
};

export const initialValues: AddTechnicalSkillFormValues = {
  name: '',
  description: '',
  ownership: { value: '', label: '' },
};
